import { Route, Switch } from "react-router-dom";
import { InviteMember } from "./InviteMember";
import { ShowSpaceGroup } from "./Show";

export interface RoutesProps {
  spaceGroup: any;
}

export const Routes = ({ spaceGroup }: RoutesProps) => (
  <Switch>
    <Route
      path="/s/:spaceSlug/invite"
      render={() => <InviteMember spaceGroup={spaceGroup} />}
    />
    <Route
      exact
      path="/s/:spaceGroupSlug"
      component={() => <ShowSpaceGroup spaceGroup={spaceGroup} />}
    />
  </Switch>
);
